// We don't display a month
export default function getIntlDateRokuyou() {
    return '';
}
